import { useState } from 'react';
import { useSelector } from 'react-redux';
import { InterviewEntity } from 'src/store/interviewApi';
import { selectSortedInterviews } from 'src/store/interviewSlice';
import { Panel } from 'src/ui/Panel';
import { Button } from 'src/ui/Button';
import { Switch } from 'src/ui/Switch';
import { Icon } from 'src/ui/Icon';
import { Badge } from 'src/ui/Badge';

export interface OutlineProps {
  onAddNew: () => void;
  setSelectedInterview: (interview: InterviewEntity, scroll: boolean) => void;
}

const Outline = ({ onAddNew, setSelectedInterview }: OutlineProps) => {
  const orderedInterviews = useSelector(selectSortedInterviews);
  const [useAsSummary, setUseAsSummary] = useState(false);

  const showInterviews = useAsSummary
    ? orderedInterviews.filter((interview) => interview.useAsSummary)
    : orderedInterviews;

  return (
    <Panel
      className="grow"
      title="Outline"
      icon="list-tree"
      headerRight={
        <Button
          variant="primary"
          size="sm"
          iconOnly
          title="Add interview"
          onClick={onAddNew}
        >
          <Icon name="plus" size={16} />
        </Button>
      }
    >
      <div className="col" style={{ height: '100%' }}>
        <label
          className="row gap-2"
          style={{
            fontSize: 'var(--fs-xs)',
            color: 'var(--text-secondary)',
            padding: '0 2px 10px',
            borderBottom: '1px solid var(--border)',
            marginBottom: 8,
            cursor: 'pointer',
          }}
        >
          <Switch size="sm" checked={useAsSummary} onChange={setUseAsSummary} />
          Use as summary only
        </label>
        <div className="grow scroll-y" style={{ margin: '0 -6px' }}>
          {showInterviews.map((interview) => (
            <div
              key={interview.id}
              role="button"
              tabIndex={0}
              className="list-row"
              onClick={() => setSelectedInterview(interview, true)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ')
                  setSelectedInterview(interview, true);
              }}
            >
              <div className="grow" style={{ minWidth: 0 }}>
                <div className="row gap-2">
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: 'var(--fs-sm)',
                      textDecoration: interview.disabled
                        ? 'line-through'
                        : 'none',
                      color: interview.disabled
                        ? 'var(--text-muted)'
                        : 'var(--text)',
                    }}
                  >
                    {interview.sequence}. {interview.name}
                  </span>
                  {interview.useAsSummary && (
                    <Icon
                      name="star"
                      size={12}
                      style={{ color: 'var(--amber-solid)' }}
                    />
                  )}
                </div>
              </div>
              {interview.disabled && (
                <Badge color="gray" size="sm">
                  Off
                </Badge>
              )}
            </div>
          ))}
        </div>
      </div>
    </Panel>
  );
};

export default Outline;
